// Shape do store do módulo Solicitações — UNIÃO de dois domínios disjuntos:
//
// 1) Comunicação (chat) — espelha o store do atendimento (desacoplado: namespace
//    `solicitacoes`, store próprio): conversas/mensagens/mode/replyTo/respostasRapidas.
//
// 2) Solicitações 100% REAL (backend aawz_solicitacoes). `sessao` define a
//    persona/contexto ativo (escritório + profissional logado) e dirige o escopo das
//    cargas. Os blocos { loading, lastUpdate, data } guardam o catálogo + listagem
//    principal e as cargas das telas de Visão Geral e Detalhe — o `lastUpdate`
//    (carimbado pelas mutations SET_*) é a fonte do "carregado" (derivado pelos
//    getters), substituindo as flags *Carregado avulsas.
export default {
  // === Comunicação (chat) ===
  conversas: [],
  mensagens: [],
  selectedConversa: null,
  loadingConversas: false,
  loadingMensagens: false,
  uploadProgress: null,
  replyTo: null,
  noteMode: false,
  editingMessage: null,
  respostasRapidas: [],
  filtroStatus: null,
  filtroProfissional: null,
  // Modo da view adaptativa (generator = cliente gera; responder = interno
  // responde). Definido no `created` da view via SET_MODE com base em ser o
  // escritório EXECUTOR (ehEscritorioInternoAawz — id_interno 2976), NÃO mais
  // IS_INTERNAL. As actions propagam para a api a cada chamada — assim o
  // polling/sync usa sempre o mesmo modo, sem "trocar" entre chamadas.
  mode: 'generator',

  // === Solicitações REAIS (backend aawz_solicitacoes) ===
  // Listagem principal de solicitações (carga via apiSolicitacoes.carregar).
  solicitacoes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  areas: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  tipos: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Catálogo BACKOFFICE (esteira interna do backoffice) — slot ADITIVO, não
  // substitui/altera `tipos`/`areas` acima (estes seguem sendo o catálogo
  // estratégico consumido por Comunicação, Calendário, Jornada, Catálogo,
  // Settings e WS thread). Mesmo shape { loading, lastUpdate, data }.
  catalogoBackoffice: {
    tipos: {
      loading: false,
      lastUpdate: null,
      data: [],
    },
    areas: {
      loading: false,
      lastUpdate: null,
      data: [],
    },
  },
  tarefas: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  arquivos: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Configurações (visão INTERNA AAWZ) — Settings > Solicitações. Cada bloco
  // segue o mesmo padrão { loading, lastUpdate, data } dos blocos reais acima.
  //  - tipos:    catálogo de tipos de solicitação [{ id, nome, id_area }]
  //  - vinculos: vínculos tipo×conexão [{ id, id_solicitacao_tipo, id_conexao, ativo }]
  //  - conexoes: conexões (times) do atendimento [{ id, nome }]
  configuracoes: {
    tipos: {
      loading: false,
      lastUpdate: null,
      data: [],
    },
    vinculos: {
      loading: false,
      lastUpdate: null,
      data: [],
    },
    conexoes: {
      loading: false,
      lastUpdate: null,
      data: [],
    },
    // vinculosEstagio: matriz serviço×etapa (obrigatoriedade por estágio)
    // [{ id, id_tipo, nivel_estagio, obrigatorio }] — carga via
    // apiConfiguracoes.listarVinculosEstagio; toggle otimista via
    // upsertConfigVinculoEstagio.
    vinculosEstagio: {
      loading: false,
      lastUpdate: null,
      data: [],
    },
  },
  // Pergunta ancorada que a faixa do Consultor (Jornada) leva até a aba do Consultor
  // Estratégico: gravada antes de navegar e limpa na leitura. Declarada aqui (e não criada
  // sob demanda) porque o Vue 2 não detecta chave nova em objeto reativo.
  // Query string e GlobalBus foram rejeitados: a primeira deixa um prompt de LLM editável na
  // barra de endereço; o segundo emite para um destino que ainda não montou.
  perguntaPendenteConsultor: '',
  // Painel lateral do Consultor no Hub aberto. Mora no Vuex, não no componente:
  // o `RouterView` é chaveado pelo path (`app.vue`), então um flag local morreria
  // a cada navegação — mesmo motivo do painel do Especialista Fee-Based.
  consultorPainelAberto: false,
  // Sessão/contexto ativo: { idEscritorio, idProfissional, gestor, isInternal }.
  sessao: null,
  loading: false,
  loaded: false,
  // === OPERACAO_AAWZ (AAWZ profissional) — visão CROSS-OFFICE das solicitações que os escritórios
  // estão abrindo (backend aawz_solicitacoes/interno). Mesmo block-pattern { loading, lastUpdate,
  // data }; carga via apiSolicitacoesOperacaoAawz (que commita estes blocos). A lista crua /interno já
  // traz nome_tipo + nome_escritorio + progresso + status + data_registro/data_fim.
  operacaoAawzSolicitacoes: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // Cache de árvores pm_task por solicitação ({ [id]: arvore[] }) — alimentado pela fila (busca em
  // paralelo as tarefas de cada solicitação) p/ derivar os PRAZOS na tabela. Reusado pelo detalhe.
  operacaoAawzArvores: {},
  // Tarefas de SOLICITAÇÃO para a aba TAREFAS — recorte do board do Gestão de Tarefas (pasta/sprint
  // "Solicitações AAWZ") mantendo só as raízes que são de solicitação (mapeadas por id_tarefa),
  // enriquecidas com meta de filtro (_area/_cliente/_solicitacaoId). `folderId`/`sprintId` guardam o
  // contexto do board (a view faz selectSprint p/ o task-list-view agrupar nativo por status).
  operacaoAawzBoardTasks: {
    loading: false,
    lastUpdate: null,
    data: [],
    folderId: null,
    sprintId: null,
  },
  // DETALHE interno (solicitação crua + árvore pm_task + anexos; mesmo padrão do detalhe P1).
  operacaoAawzDetalhe: {
    loading: false,
    lastUpdate: null,
    erro: false,
    arvoreCarregando: false,
    data: {
      solicitacao: null,
      arvore: [],
      arquivos: [],
    },
  },
}
